import React, { useState, useEffect, useRef } from 'react';
import { Card, Col, Modal, Row, Spin, Switch,DatePicker, Table, message, Image, InputRef, Radio, Button, RadioChangeEvent, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { deletebusiness, BusinessVerify, BusinessTrusted, updateBusinessStatus, getmlmBusiness, Userplan, getAllPackages } from '../../../../utils/API';
import { DeleteFilled, FilePdfFilled, QrcodeOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import pdfMake from 'pdfmake/build/pdfmake'; // pdfMake for generating PDFs
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import QRCode from 'qrcode';
import dayjs, { Dayjs } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import imageforpdf from "./ImagesForPdf.json"

dayjs.extend(isBetween);

const { RangePicker } = DatePicker;

pdfMake.vfs = pdfFonts as any;
const daysInMonth = 30; // Number of days in a month
interface Customer {
    _id: number;
    id: number;
    businessName: string;
    area: string;
    email: string;
    mobileNumber: string;
    isVerified: boolean;
    galleryImage: string[];
}

const BusinesslistMLM: React.FC = () => {
    console.log("imageforpdf",imageforpdf[1].image)
    const [customerData, setCustomerData] = useState<Customer[]>([]);
    const [filteredData, setFilteredData] = useState<any>([]);
    const [searchQuery, setSearchQuery] = useState(''); // State to track search query
    const [loading, setLoading] = useState<boolean>(false);
    const [isFeatured, setIsFeatured] = useState(false);
    const [isHome, setIsHome] = useState(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [searchText, setSearchText] = useState<string>('');
    const [packageData, setPackageData] = useState<any>([]);
    const [selectedPackage, setSelectedPackage] = useState<string | null>(null);
    const [calculatedPlanAmount, setCalculatedPlanAmount] = useState<number>(0);
    const [selectedDuration, setSelectedDuration] = useState<number | null>(null);
    const [selectedBusinessId, setSelectedBusinessId] = useState<any>({});
    const [userId, setuserId] = useState();
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const imageUrl = process.env.REACT_APP_IMAGE_URL + '/businesse/';
     const [dateRange, setDateRange] = useState<[Dayjs, Dayjs] | null>(null);
    const navigate = useNavigate();

     const FetchCustomerData = (page: number,businessName : string, dateRange: [Dayjs, Dayjs] | null) => {
          setLoading(true);
  
          const startDate = dateRange ? dateRange[0].format("YYYY-MM-DD") : undefined;
          const endDate = dateRange ? dateRange[1].format("YYYY-MM-DD") : undefined;
  
          getmlmBusiness(page, "", "", startDate, endDate, businessName)
              .then((response: any) => {
                  const filteredCustomerData = response.data.filter((customer: any) => !customer.isDeleted);
                  setCustomerData(filteredCustomerData);
                  setFilteredData(filteredCustomerData); // Set initial filtered data
                  setTotalPages(response.totalPages);
              })
              .catch((error: any) => {
                  message.error("Network error. Please try again.");
              })
              .finally(() => {
                  setLoading(false);
              });
      };

       const filterData = (query: string, dates: [Dayjs, Dayjs] | null) => {
              let filtered = customerData.filter((item: any) =>
                  item.businessName.toLowerCase().includes(query)
              );
          
              console.log("Selected Date Range:", dates);
          
              if (dates && dates[0] && dates[1]) {
                  filtered = filtered.filter((item: any) => {
                      const itemCreatedAt = dayjs(item.createdAt); // Ensure it's converted to Dayjs
                      console.log("Item Created At:", itemCreatedAt.format()); 
          
                      // Ensure proper start and end range for filtering
                      const startDate = dates[0].startOf("day");
                      const endDate = dates[1].endOf("day");
          
                      return itemCreatedAt.isBetween(startDate, endDate, "day", "[]");
                  });
              }
              console.log("Filtered Data:", filtered);
              setFilteredData(filtered);
          };
          
  
      const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
             const query = e.target.value.toLowerCase();
             setSearchQuery(query);
             console.log("Query", query);
             
             FetchCustomerData(currentPage, query, dateRange); // Pass the query to the backend
         };
     
         const handleDateChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
             console.log("Selected Dates:", dates);
         
             if (dates && dates[0] && dates[1]) {
                 setDateRange(dates as [Dayjs, Dayjs]); // Ensure the type is correct
                 FetchCustomerData(currentPage, searchQuery, dates as [Dayjs, Dayjs]); // Fetch with date range
             } else {
                 setDateRange(null);
                 FetchCustomerData(currentPage, searchQuery, null);
             }
         };
         

    useEffect(() => {
        FetchCustomerData(currentPage, searchQuery, dateRange);
    }, [currentPage, searchQuery, dateRange]);

 
    const fetchPackageData = async () => {
        try {
            const data = await getAllPackages();

            setPackageData(data);
        } catch (error) {
            message.error("Something went wrong");
        }
    };
    useEffect(() => {
        fetchPackageData();  // This effect will run only once when the component mounts
    }, []);

    const showDeleteConfirmation = (id: number) => {
        Modal.confirm({
            title: 'Confirm Deletion',
            content: 'Are you sure you want to delete this customer?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: () => handleDeleteConfirmation(id, 1),
            onCancel: () => handleDeleteConfirmation(id, 0),
        });
    };

    const handleDeleteConfirmation = (id: number, flag: number) => {
        if (flag === 1) {
            deletebusiness(id).then(() => {
                message.success('Business Deleted successfully');
                FetchCustomerData(currentPage, searchQuery, dateRange);
            });
        }
    };

    // const handleSearch = (value: string) => {
    //     setSearchText(value);
    // };

    const handleEditRedirect = (record: Customer) => {
        navigate(`/backend/users/${record._id}/edit`);
    };

    const BusinessVerifyd = (record: Customer , checked : boolean) => {
        const newStatus = checked ? 2 : 1;
    
        BusinessVerify(record._id, { isVerified: newStatus })
            .then((response: any) => {
                if (response.status === 200) {
                    message.success(response.data.message);
                    FetchCustomerData(currentPage, searchQuery, dateRange);
                } else {
                    message.error("Something went wrong");
                }
            })
            .catch((error: any) => {
                message.error(error.response.data.message);
            });
    };

    const Businesstrusted = (record: any, checked: boolean) => {
        const newStatus = checked ? 2 : 1;
    
        BusinessTrusted(record._id, { isTrusted: newStatus })
            .then((response: any) => {
                if (response.status === 200) {
                    message.success(response.data.message);
    
                    // Update local state immediately (if applicable)
                    record.isTrusted = newStatus;
                   
    
                    FetchCustomerData(currentPage, searchQuery, dateRange);
                } else {
                    message.error("Something went wrong");
                }
            })
            .catch((error: any) => {
                message.error(error.response.data.message);
            });
    };

    const updateIsHome = (record: Customer, checked: boolean) => {
        updateBusinessStatus(record._id, { isHome: checked ? 1 : 0 })
            .then((response: any) => {
                if (response.status === 200) {
                    message.success("Status updated successfully");
                    FetchCustomerData(currentPage, searchQuery, dateRange);
                } else {
                    message.error("Something went wrong");
                }
            })
            .catch((error: any) => {
                message.error(error.response.data.message);
            });
    };

    const updateIsFeatured = (record: Customer, checked: boolean) => {
        updateBusinessStatus(record._id, { isFeatured: checked ? 1 : 0 })
            .then((response: any) => {
                if (response.status === 200) {
                    message.success("Status updated successfully");
                    FetchCustomerData(currentPage, searchQuery, dateRange);
                } else {
                    message.error("Something went wrong");
                }
            })
            .catch((error: any) => {
                message.error(error.response.data.message);
            });
    };

    const handleIconClick = (record: any) => {
        setSelectedBusinessId(record._id); // Assuming you have a state variable for this
        setuserId(record.userId._id);
        if (Array.isArray(record.packageID) && record.packageID.length > 0 && record.packageID[0]._id) {
            setSelectedPackage(record.packageID[0]._id); // Pre-select the purchased package in the modal
            setSelectedDuration(record.month); // Pre-set the plan amount based on the package
        } else {
            // Handle the case where there is no package or packageID is empty
            setSelectedPackage(null); // Or some default value
            setCalculatedPlanAmount(0); // Reset or set a default plan amount
        }
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setSelectedBusinessId(null);
        setSelectedPackage(null);
        setCalculatedPlanAmount(0);
        setSelectedDuration(null);
        setIsModalVisible(false);
    };

    const handlePackageSelect = (e: RadioChangeEvent) => {
        const selectedPackageId = e.target.value;
        const selectedPackageData = packageData.find((pkg: { _id: any; }) => pkg._id === selectedPackageId);

        if (selectedPackageData) {
            setSelectedPackage(selectedPackageId);
            setCalculatedPlanAmount(selectedPackageData.price); // Set the plan amount based on the selected package
        }
    };

    const handleDurationSelect = (e: any) => {
        setSelectedDuration(e.target.value);
    };

        const updateIsPhysically = (record: Customer, checked: boolean) => {
            updateBusinessStatus(record._id, { isPhysicallyVerified : checked ? 1 : 0 })
                .then((response: any) => {
                    if (response.status === 200) {
                        message.success("Status updated successfully");
                        FetchCustomerData(currentPage, searchQuery, dateRange);
                    } else {
                        message.error("Something went wrong");
                    }
                })
                .catch((error: any) => {
                    message.error(error.response.data.message);
                });
        };

    const handleConfirmSelection = async () => {
        if (selectedPackage && selectedDuration) {
            // Calculate totalAmount based on planAmount and selectedDuration
            const calculatedTotalAmount = calculatedPlanAmount * (selectedDuration * daysInMonth);

            // Construct the userPlanData object
            const userPlanData = {
                businessId: selectedBusinessId,  // Replace this with the actual business_id
                userId: userId,          // Replace this with the actual userId
                packageID: selectedPackage,      // This will be the selected package
                isActive: 1,                     // Default value is 1
                totalAmount: calculatedTotalAmount,  // Use calculated total amount
                planAmount: calculatedPlanAmount,    // Use plan amount for 1 month
                month: selectedDuration          // This will be the selected duration (month)
            };

            try {
                const response = await Userplan(userPlanData);
                if (response.status === 200) {
                    message.success(response.data.message);
                    handleModalClose();
                    FetchCustomerData(currentPage, searchQuery, dateRange);
                } else {
                    message.error("Unexpected response status: " + response.status);
                }
            } catch (error) {
                message.error('An error occurred while submitting the package selection');
            }
        } else {
            message.error('Please select a package and duration');
        }
    };


   const columns = [
         {
             title: (
                 <div style={{ fontWeight: "bold", fontSize: "10px", color: "#a6a6a6" }}>
                     Images
                 </div>
             ),
             dataIndex: "galleryImage",
             key: "galleryImage",
             render: (galleryImage: string[]) => (
                 <div>
                     {galleryImage && galleryImage.length > 0 && (
                         <Image
                             src={`${imageUrl}${galleryImage[0]}`} // Adjust path as needed
                             alt={`Thumbnail 1`}
                             className='rounded-md'
                             style={{ width: "80px", height: "60px", marginRight: "5px" }}
                         />
                     )}
                 </div>
             ),
         },
         {
             title: <div style={{ fontWeight: 'bold', fontSize: "10px", color: "#a6a6a6" }}>Name</div>,
             dataIndex: 'businessName',
             key: 'businessName',
         },
         {
             title: <div style={{ fontWeight: 'bold', fontSize: "10px", color: "#a6a6a6" }}>Location</div>,
             dataIndex: 'city',
             key: 'city',
             render: (text: any, record: any) => {
                 return <div>{record.city} , {record.state}</div>;
             }
         },
         {
             title: <div style={{ fontWeight: 'bold', fontSize: "10px", color: "#a6a6a6" }}>Contact</div>,
             dataIndex: 'mobileNumber',
             key: 'mobileNumber',
         },
         {
             title: <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>Is Home</div>,
             dataIndex: 'isHome',
             key: 'isHome',
             render: (isHome: boolean, record: any) => {
                 return (
                     <Switch
                         checked={isHome}
                         style={{ marginRight: '10px', backgroundColor: isHome ? 'rgb(251, 202, 37)' : 'gray' }}
 
                         onChange={(checked) => updateIsHome(record, checked)}
                     />
                 );
             },
         },
         {
             title: <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>Is Phy Verified</div>,
             dataIndex: 'isPhysicallyVerified',
             key: 'isPhysicallyVerified',
             render: (isPhysicallyVerified: boolean, record: any) => {
                 return (
                     <Switch
                         checked={isPhysicallyVerified}
                         style={{ marginRight: '10px', backgroundColor: isPhysicallyVerified ? 'rgb(251, 202, 37)' : 'gray' }}
 
                         onChange={(checked) => updateIsPhysically(record, checked)}
                     />
                 );
             },
         },
         {
             title: <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>Is Featured</div>,
             dataIndex: 'isFeatured',
             key: 'isFeatured',
             render: (isFeatured: boolean, record: any) => {
                 return (
                     <Switch
                         checked={isFeatured}
                         style={{ marginRight: '10px', backgroundColor: isFeatured ? 'rgb(251, 202, 37)' : 'gray' }}
                         onChange={(checked) => updateIsFeatured(record, checked)}
                     />
                 );
             },
         },
         {
             title: <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>Verified</div>,
             dataIndex: 'isVerified',
             key: 'isVerified',
             render: (isVerified: any, record: any) => {
               
                 return (
                     <Switch
                         checked={isVerified === 2}
                      
                    
                         style={{ marginRight: '10px', backgroundColor: isVerified === 2 ? 'rgb(251, 202, 37)' : 'gray' }}
                         onChange={(checked) => BusinessVerifyd(record, checked)}
                     />
                 );
             },
             sorter: (a: any, b: any) => a.isVerified - b.isVerified,
             filters: [
                 { text: 'Verified', value: 2 },
                 { text: 'Not Verified', value: 0 },
                 { text: 'Pending', value: 1 }
             ],
             onFilter: (value: any, record: any) => record.isVerified === value,
         },
         {
             title: <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>Trusted</div>,
             dataIndex: 'isTrusted',
             key: 'isTrusted',
             render: (isTrusted: any, record: any) => {
               
                 return (
                     <Switch
                         checked={isTrusted === 2}
                       
                         style={{ marginRight: '10px', backgroundColor: isTrusted === 2 ? 'rgb(251, 202, 37)' : 'gray' }}
                         onChange={(checked) => Businesstrusted(record, checked)}
                     />
                 );
             },
             sorter: (a: any, b: any) => a.isTrusted - b.isTrusted,
             filters: [
                 { text: 'Trusted', value: 2 },
                 { text: 'Not Trusted', value: 1 }
             ],
             onFilter: (value: any, record: any) => record.isTrusted === value,
         },
         {
            title: (
                <div style={{ fontWeight: "bold", fontSize: "10px", color: "#a6a6a6" }}>
                    Plan
        </div>
            ),
            dataIndex: 'businessId', // Use a more relevant field like 'businessId'
            key: 'businessId',
            width : 150,
            render: (text: any, record: any) => {
                const isSubscribed = record.isSubscibe === 1;
                
                return (
                   <>
                    <Row gutter={12}>
                       
                       
                        <Col span={24}>
                        <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            color: '#FFC107',
                        }}
                        onClick={() => handleIconClick(record)} // Pass the entire record for context
                    >
                        <ShoppingCartOutlined style={{ fontSize: '18px', marginRight: '8px' }} />
                        <span style={{ fontWeight: '500' }}>
                            {isSubscribed ? 'Upgrade' : 'Buy Plan'}
                        </span>
                    </div>
                    
                        </Col>
                    </Row>
                   </>
                );
            },
        },
        {
            title: (
              <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>
                Action
              </div>
            ),
            dataIndex: 'businessId',
            key: 'businessId',
            width: 150,
            render: (text: any, record: any) => {
              const generatePdfWithQrCode = async (record: any) => {
                console.log("record daa", record)
                const businessId = record._id;
                try {          
                  const qrCodeUrl = await generateQrCodeAsDataUrl(businessId);
                
                  const docDefinition: TDocumentDefinitions = {
                    pageSize: 'A5',
                    background: [
                        {
                            canvas: [
                                {
                                    type: 'rect',
                                    x: 0,
                                    y: 0,
                                    w: 421.89, // A5 width in points
                                    h: 595.28, // A5 height in points
                                    color: '#FAF7EF' // Set your desired background color
                                }
                            ]
                        },
                        {
                            image: imageforpdf[0].image,
                            alignment: "center",
                            margin: [0, 10, 0, 20],
                            width: 421.89,
                            height: 595.28,
                            absolutePosition: { x: 0, y: 0 } // Ensures the image is placed at (0,0)
                        }
                    ],
                    
                    content: [
                        {
                            image: imageforpdf[1].image, // Embed the QR Code
                            width: 300,
                            margin: [0, 0, 0, 0],
                            alignment: "center",
                         
                          },
                          {
                            canvas: [
                              {
                                type: 'rect',
                                x: 105,
                                y: 13,
                                w: 125  , // Width of the QR code
                                h: 125, // Height of the QR code
                                // brown border around the QR code
                                lineColor: '#A57611',
                                lineWidth: 7, // Border thickness
                                },
                            ],
                          },
                          {
                            image: qrCodeUrl, // Embed the QR Code
                            absolutePosition: { x: 35, y: 133 }, // Ensures the image is placed at (0,0)
                            width: 118,
                            height: 115,
                            alignment: "center",
                          },
                          
                      {
                        text : "Share Your Experience with Us.!",
                        alignment: "center",
                        fontSize: 15,
                        margin: [0, 20, 0, 20],
                   
                      },
                      {
                        text: `${record.businessName}`,
                        alignment: "center",
                        fontSize: 20,
                        bold: true,
                        margin: [0, 0, 0, 8], 
                      },
                      {
                        image: imageforpdf[2].image, // Embed the QR Code
                        alignment: "center",
                        margin: [0, 0, 0, 25],
                      },
                      {
                        text : `Business Category : ${record.categoryId[0].name}`,
                        alignment: "center",
                        fontSize: 16,
                        margin: [0, 0, 0, 25],
                      },
                      {
                        image : imageforpdf[3].image,
                        alignment : "center",
                        
                        margin: [0, 20, 0, 10],
                      },
                      {
                        image: imageforpdf[2].image, // Embed the QR Code
                        alignment: "center",
                        margin: [0, -10, 0, 20],
                      },
                      {
                        text : "Building Trust, One Review at a Time!",
                        alignment: "center",
                        fontSize: 15,
                        margin: [0, 0, 0, 5],
                      },
                      {
                        text : "www.net4surge.com",
                        alignment: "center",
                        fontSize: 12,
                      }
                    ],
                  };
          
                  // Generate and open the PDF
                //   pdfMake.createPdf(docDefinition).open();
                  pdfMake.createPdf(docDefinition).download(`${record.businessName}_qr_Code.pdf`);
                } catch (error) {
                  console.error("Error generating QR Code or PDF:", error);
                }
              };
              
              // Helper function to generate a QR Code as a Data URL using the 'qrcode' library
              const generateQrCodeAsDataUrl = (value: string): Promise<string> => {
                const address = `${window.location.origin}/business/${record.slug}`;
                console.log("Address", address);
              
                return new Promise((resolve, reject) => {
                  QRCode.toDataURL(
                    address,
                    { width: 150, margin: 2 }, // Set margin to 0 to remove extra space
                    (err: any, url: any) => {
                      if (err) {
                        reject(err);
                      } else {
                        resolve(url);
                      }
                    }
                  );
                });
              };
              

              const generatePdf = async (record: any) => {
                const businessId = record._id;
                const addressFontSize = `${record.streetName} ${record.city} ${record.state} ${record.pincode}`.length > 40 ? 16 : 20;
                const businessNameFontSize = record.businessName.length > 30 ? 12 : 18;
                const xaxis =record.businessName.length > 30 ? 0 : 0; 
                const yaxis =record.businessName.length > 30 ? 0 : 0;
                console.log("Business Data", record)
                try {
               
                  // Define the PDF document
                  const docDefinition: TDocumentDefinitions = {
                    pageSize: 'A4',
                    background : [{
                        
                            image :  imageforpdf[4].image,
                            alignment : "center",
                            width: 595.28,  // A4 page width in points
      height: 841.89, // A4 page height in points
                        },
                    ],
                    content: [
                      // Letter Heading
                      {
                        image : imageforpdf[1].image,
                        alignment : "center",
                        width:410,
                        absolutePosition: {x: 45, y: 58},
                      
                    },
                     
                      // Business Name Introduction
                      {
                        text: `Dear ${record ? record.contactPersonName : record.businessName},`,
                        fontSize: 25,
                        
                        margin: [30, 130, 0, 10],
                        alignment: "center",
                      },
                      
                      // Body Text
                      {
                        text: `Congratulations! Your  ${record.businessName} is now on Net4Surge – your business partner for digital automation and brand creation.`,
                        fontSize: 18,
                       
                        alignment: "center",
                        color: "#825108",
                        margin: [20, 20, 20, 35],
                      },
                  
                      // Business Information Section
                      {
                        text: `CONGRATULATIONS`,
                        fontSize: `${record.businessName}`.length > 30 ? 25 : 40,
                        bold: true,
                        color: "#825108",
                        alignment: "center",
                      },
                      {
                        image : imageforpdf[5].image,
                        width: 350,
                        height: 10,
                       absolutePosition: {x: 40, y: 370},
                        alignment: "center",
                    },

                      {
                        text: `${record.businessName}`,
                        fontSize: `${record.businessName}`.length > 30 ? 18 : 18,
                        color: "#825108",
                        alignment : "center",
                        bold: true,
                        margin: [0, 35, 0, 20],
                      },
                      {
                        text : `${record.categoryId[0].name}`,
                        color: "#825108",
                        bold: true,
                        alignment: "center",
                        fontSize: 18,
                        margin: [0, 0, 0, 20],
                        
                      },
                      {
                        image : imageforpdf[2].image,
                      
                        alignment: "center",
                    },
                    {
                        text : ` Address`,
                        color: "#825108",
                        bold: true,
                        alignment: "center",
                        fontSize: 20,
                        margin: [0, 10, 0, 5],
                        
                      },
                    {
                        text : ` ${record.streetName} ${record.city} ${record.state} ${record.pincode}`,
                        color: "#825108",
                        bold: true,
                        alignment: "center",
                        fontSize: addressFontSize,
                        margin: [0, 15, 0, 20],
                        
                      },
                      {
                        text: `Thank you for choosing Net4Surge as your business
growth partner. We look forward to seeing your business
thrive on our platform.`,
fontSize: `${record.businessName}`.length > 30 ? 15 : 15,
                       
                        alignment: "center",
                        color: "#825108",
                        margin: [40, 40, 40, 20],
                      },
                      {
                        image : imageforpdf[2].image,
                            width: 300,
                        alignment: "center",
                    },
                    {
                        image : imageforpdf[6].image,
                        width: 200,
                        margin: [0, 10, 0, 10],
                        alignment: "center",
                    },
                    ],
                    styles: {
                      header: {
                        fontSize: 18,
                        bold: true,
                        alignment: "center",
                        margin: [30, 0, 0, 10],
                      },
                      subheader: {
                        fontSize: 14,
                        margin: [30, 0, 0, 10],
                      },
                      body: {
                        fontSize: 12,
                      },
                    },
                  };
                  
                  // Generate and open the PDF
                //   pdfMake.createPdf(docDefinition).download(`${record.businessName}.pdf`);
                                  pdfMake.createPdf(docDefinition).open();
                //   pdfMake.createPdf(docDefinition).open();
                } catch (error) {
                  console.error("Error generating PDF:", error);
                }                  
            }
              return (
                <Row gutter={12}>
                     <Col span={8}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: '#FFC107',
                      }}
                      onClick={() => showDeleteConfirmation(record._id)}
                    >
                      <DeleteFilled style={{ fontSize: '18px', marginRight: '18px' }} />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: '#FFC107',
                      }}
                      onClick={() => generatePdfWithQrCode(record)}
                    >
                      <QrcodeOutlined style={{ fontSize: '18px', marginRight: '18px' }} />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: '#FFC107',
                      }}
                      onClick={() => generatePdf(record)}
                    >
                      <FilePdfFilled style={{ fontSize: '18px', marginRight: '18px' }} />
                    </div>
                  </Col>
                </Row>
              );
            },
          },          
     ];

    return (
        <>
               <Row className="m-2" align={"middle"}>
                <Col
                    xs={24}
                    sm={24}
                    md={9}
                    xl={6}
                    xxl={6}
                    className="d-flex justify-content-start font-bold"
                >
                    <h2 className="text-2xl">Businesses</h2>
                </Col>
               <Col xs={24} sm={24} md={24} xl={18} xxl={18} className="d-flex justify-content-end">
                                  <Input
                                      placeholder="Search by Business Name"
                                      value={searchQuery}
                                      className="Allinput"
                                      onChange={handleSearch}
                                      style={{ width: 300 }}
                                  />
                                  <RangePicker
                                      value={dateRange}
                                      onChange={handleDateChange}
                                      style={{ marginLeft: 10 }}
                                  />
                              </Col>
            </Row>
            <Row>
                <Col
                    style={{ backgroundColor: "#ffffff", borderRadius: "12px" }}
                    xs={24}
                    sm={24}
                    md={24}
                    xl={24}
                    xxl={24}
                >
                    <Card className="bg-white border " style={{ borderRadius: "12px" }}>
                        <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
                            <Spin spinning={loading}>
                                <div style={{ overflowX: 'auto' }}>
                                <Table
                                        columns={columns}
                                        dataSource={filteredData} // Use the filtered data
                                        scroll={{ x: true }}
                                        pagination={{
                                            current: currentPage,
                                            total: totalPages * 10,
                                            onChange: (page) => setCurrentPage(page),
                                        }}
                                    />
                                </div>
                            </Spin>
                        </Col>
                    </Card>
                </Col>
            </Row>
            <Modal
                title={<h2 className="text-lg font-semibold">Package Information</h2>}
                visible={isModalVisible}
                onCancel={handleModalClose}
                footer={[
                    <Button key="cancel" onClick={handleModalClose} className="mr-2">
                        Cancel
                    </Button>,
                    <Button
                        key="confirm"
                        type="primary"
                        onClick={handleConfirmSelection}
                        className="bg-yellow-500 hover:bg-yellow-600 text-white"
                    >
                        Submit
                    </Button>
                ]}
                className="p-4 rounded-lg"
            >
                <p className="font-semibold mb-4">Choose the package</p>
                <Radio.Group
                    onChange={handlePackageSelect}
                    value={selectedPackage}
                    className="flex flex-col mb-4 space-y-2"
                >
                    {packageData.map((pkg: any) => (
                        <Radio
                            key={pkg._id}
                            value={pkg._id}  // Use the package _id as the value
                            className="p-2 border border-yellow-200 rounded-lg hover:border-yellow-500"
                        >
                            <span className="font-medium">{pkg.packageName}</span>: {pkg.price} Rs. / {pkg.duraction}
                        </Radio>
                    ))}
                </Radio.Group>

                <p className="font-semibold mb-4">Select duration</p>
                <Radio.Group
                    onChange={handleDurationSelect}
                    value={selectedDuration}
                    className="flex flex-col space-y-2"
                >
                    <Radio
                        value={1}
                        className="p-2 border border-gray-200 rounded-lg hover:border-yellow-500"
                    >
                        1 Month
                    </Radio>
                    <Radio
                        value={3}
                        className="p-2 border border-gray-200 rounded-lg hover:border-yellow-500"
                    >
                        3 Months
                    </Radio>
                    <Radio
                        value={6}
                        className="p-2 border border-gray-200 rounded-lg hover:border-yellow-500"
                    >
                        6 Months
                    </Radio>
                    <Radio
                        value={12}
                        className="p-2 border border-gray-200 rounded-lg hover:border-yellow-500"
                    >
                        12 Months
                    </Radio>
                </Radio.Group>
            </Modal>
        </>
    );
};

export default BusinesslistMLM;